import { Pipe, PipeTransform } from '@angular/core';
import { FileResponse } from '../../../core/clients/omni-core/models';

@Pipe({
  name: 'documentFilename',
})
export class DocumentFilenamePipe implements PipeTransform {
  transform(document: FileResponse | null | undefined): string | undefined {
    if (document?.fileType.startsWith('LMA_')) {
      return document.filename.replace(/\.html$/, '.lma');
    }
    return document?.filename;
  }
}
